// 英雄战术属性表 —— 给青铜级（本地规则）AI 用
//
// 数据策略：
//   - 80 个职业赛常见英雄手工标注（基于近 12 个月 LPL/LCK/LCS/LEC 出场频率）
//   - 其他英雄按 DataDragon 主 tag 推默认值
//
// 每个英雄 5 个核心属性：
//   damageType:  'AD' | 'AP' | 'mixed'     伤害类型（对方该出 AR 还是 MR）
//   cc:          0..3                       硬控强度（0=无，3=全队减速/连环硬控）
//   frontline:   0..3                       前排能力（0=后排脆皮，3=肉坦）
//   scaling:     'early' | 'mid' | 'late'   强势期
//   engage:      0..3                       先手开团能力

const TAG_BASE = {
  Tank:     { damageType: 'AD',    cc: 2, frontline: 3, scaling: 'mid',  engage: 2 },
  Fighter:  { damageType: 'AD',    cc: 1, frontline: 2, scaling: 'mid',  engage: 1 },
  Mage:     { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Marksman: { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'late', engage: 0 },
  Assassin: { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'early', engage: 0 },
  Support:  { damageType: 'mixed', cc: 2, frontline: 1, scaling: 'mid',  engage: 1 },
};

// 关键英雄手工覆盖（按 DataDragon idName 索引）
const OVERRIDES = {
  // ====== 上单 ======
  Aatrox:      { damageType: 'AD',    cc: 2, frontline: 2, scaling: 'mid',  engage: 2 },
  Camille:     { damageType: 'AD',    cc: 2, frontline: 1, scaling: 'mid',  engage: 2 },
  Darius:      { damageType: 'AD',    cc: 1, frontline: 2, scaling: 'mid',  engage: 1 },
  Fiora:       { damageType: 'AD',    cc: 0, frontline: 1, scaling: 'mid',  engage: 0 },
  Gangplank:   { damageType: 'mixed', cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Garen:       { damageType: 'AD',    cc: 1, frontline: 3, scaling: 'mid',  engage: 1 },
  Gnar:        { damageType: 'mixed', cc: 2, frontline: 2, scaling: 'mid',  engage: 3 },
  Gragas:      { damageType: 'AP',    cc: 2, frontline: 3, scaling: 'mid',  engage: 3 },
  Gwen:        { damageType: 'AP',    cc: 0, frontline: 1, scaling: 'mid',  engage: 0 },
  Irelia:      { damageType: 'mixed', cc: 1, frontline: 1, scaling: 'mid',  engage: 1 },
  Jax:         { damageType: 'mixed', cc: 1, frontline: 1, scaling: 'late', engage: 0 },
  Jayce:       { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'early',engage: 0 },
  KSante:      { damageType: 'AD',    cc: 2, frontline: 3, scaling: 'mid',  engage: 3 },
  Kennen:      { damageType: 'AP',    cc: 3, frontline: 1, scaling: 'mid',  engage: 3 },
  Maokai:      { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Mordekaiser: { damageType: 'AP',    cc: 1, frontline: 2, scaling: 'mid',  engage: 1 },
  Nasus:       { damageType: 'AD',    cc: 1, frontline: 2, scaling: 'late', engage: 0 },
  Olaf:        { damageType: 'AD',    cc: 0, frontline: 2, scaling: 'mid',  engage: 1 },
  Ornn:        { damageType: 'mixed', cc: 3, frontline: 3, scaling: 'late', engage: 3 },
  Poppy:       { damageType: 'AD',    cc: 2, frontline: 3, scaling: 'mid',  engage: 2 },
  Renekton:    { damageType: 'AD',    cc: 1, frontline: 2, scaling: 'early',engage: 1 },
  Riven:       { damageType: 'AD',    cc: 2, frontline: 1, scaling: 'mid',  engage: 1 },
  Sett:        { damageType: 'AD',    cc: 2, frontline: 2, scaling: 'mid',  engage: 2 },
  Shen:        { damageType: 'mixed', cc: 1, frontline: 3, scaling: 'mid',  engage: 1 },
  Sion:        { damageType: 'AD',    cc: 2, frontline: 3, scaling: 'mid',  engage: 3 },
  Urgot:       { damageType: 'AD',    cc: 1, frontline: 1, scaling: 'mid',  engage: 1 },
  Yorick:      { damageType: 'AD',    cc: 1, frontline: 1, scaling: 'late', engage: 0 },

  // ====== 打野 ======
  // 注：DataDragon 中英雄 id 没有撇号/空格（如 Belveth、JarvanIV、KhaZix），
  // 所以这里全部用"无标点"形式做 key
  Belveth:     { damageType: 'AD',    cc: 0, frontline: 1, scaling: 'late', engage: 1 },
  Diana:       { damageType: 'AP',    cc: 2, frontline: 1, scaling: 'mid',  engage: 2 },
  Ekko:        { damageType: 'AP',    cc: 2, frontline: 1, scaling: 'mid',  engage: 1 },
  Elise:       { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'early',engage: 1 },
  Evelynn:     { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Hecarim:     { damageType: 'AD',    cc: 1, frontline: 2, scaling: 'mid',  engage: 3 },
  Ivern:       { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
  JarvanIV:    { damageType: 'AD',    cc: 2, frontline: 2, scaling: 'mid',  engage: 3 },
  KhaZix:      { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Khazix:      { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Kindred:     { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  LeeSin:      { damageType: 'AD',    cc: 1, frontline: 1, scaling: 'early',engage: 2 },
  Lillia:      { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 2 },
  MasterYi:    { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'late', engage: 0 },
  Nidalee:     { damageType: 'AP',    cc: 0, frontline: 0, scaling: 'early',engage: 0 },
  Nocturne:    { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'mid',  engage: 2 },
  Rammus:      { damageType: 'mixed', cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  RekSai:      { damageType: 'AD',    cc: 1, frontline: 1, scaling: 'mid',  engage: 2 },
  Sejuani:     { damageType: 'mixed', cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Skarner:     { damageType: 'mixed', cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Trundle:     { damageType: 'AD',    cc: 1, frontline: 2, scaling: 'mid',  engage: 0 },
  Vi:          { damageType: 'AD',    cc: 2, frontline: 2, scaling: 'mid',  engage: 3 },
  Viego:       { damageType: 'AD',    cc: 1, frontline: 1, scaling: 'mid',  engage: 0 },
  XinZhao:     { damageType: 'AD',    cc: 2, frontline: 1, scaling: 'early',engage: 2 },
  Wukong:      { damageType: 'AD',    cc: 2, frontline: 2, scaling: 'mid',  engage: 3 },
  MonkeyKing:  { damageType: 'AD',    cc: 2, frontline: 2, scaling: 'mid',  engage: 3 },
  Zac:         { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },

  // ====== 中单 ======
  Ahri:        { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 1 },
  Akali:       { damageType: 'AP',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Anivia:      { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'late', engage: 0 },
  Annie:       { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 2 },
  AurelionSol: { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 1 },
  Azir:        { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 1 },
  Cassiopeia:  { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Corki:       { damageType: 'mixed', cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Galio:       { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Hwei:        { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
  Kassadin:    { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Katarina:    { damageType: 'AP',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  LeBlanc:     { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Lissandra:   { damageType: 'AP',    cc: 3, frontline: 1, scaling: 'mid',  engage: 3 },
  Lux:         { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 0 },
  Malzahar:    { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
  Neeko:       { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 2 },
  Orianna:     { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'late', engage: 3 },
  Ryze:        { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Sylas:       { damageType: 'AP',    cc: 1, frontline: 1, scaling: 'mid',  engage: 1 },
  Syndra:      { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Taliyah:     { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
  TwistedFate: { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
  Veigar:      { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Viktor:      { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Yasuo:       { damageType: 'AD',    cc: 1, frontline: 1, scaling: 'mid',  engage: 1 },
  Yone:        { damageType: 'AD',    cc: 1, frontline: 1, scaling: 'mid',  engage: 1 },
  Zed:         { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Ziggs:       { damageType: 'AP',    cc: 0, frontline: 0, scaling: 'late', engage: 0 },
  Zoe:         { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },

  // ====== ADC ======
  Aphelios:    { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Ashe2:       { damageType: 'AD',    cc: 2, frontline: 0, scaling: 'late', engage: 1 },
  Ashe:        { damageType: 'AD',    cc: 2, frontline: 0, scaling: 'late', engage: 1 },
  Caitlyn:     { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Draven:      { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'early',engage: 0 },
  Ezreal:      { damageType: 'mixed', cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Jhin:        { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Jinx:        { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'late', engage: 0 },
  Kaisa:       { damageType: 'mixed', cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Kalista:     { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  KogMaw:      { damageType: 'mixed', cc: 0, frontline: 0, scaling: 'late', engage: 0 },
  Lucian:      { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  MissFortune: { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Nilah:       { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Samira:      { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Senna:       { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Sivir:       { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },
  Smolder:     { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'late', engage: 0 },
  Tristana:    { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Twitch:      { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'late', engage: 0 },
  Varus:       { damageType: 'mixed', cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
  Vayne:       { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Xayah:       { damageType: 'AD',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Zeri:        { damageType: 'AD',    cc: 0, frontline: 0, scaling: 'mid',  engage: 0 },

  // ====== 辅助 ======
  Alistar:     { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Bard:        { damageType: 'AP',    cc: 2, frontline: 1, scaling: 'mid',  engage: 2 },
  Blitzcrank:  { damageType: 'AP',    cc: 2, frontline: 2, scaling: 'early',engage: 3 },
  Braum:       { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 2 },
  Janna:       { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Karma:       { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Leona:       { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Lulu:        { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Milio:       { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Morgana:     { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
  Nami:        { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  Nautilus:    { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Pyke:        { damageType: 'AD',    cc: 2, frontline: 1, scaling: 'mid',  engage: 2 },
  Rakan:       { damageType: 'AP',    cc: 3, frontline: 2, scaling: 'mid',  engage: 3 },
  Rell:        { damageType: 'AP',    cc: 3, frontline: 3, scaling: 'mid',  engage: 3 },
  Renata:      { damageType: 'AP',    cc: 2, frontline: 1, scaling: 'mid',  engage: 1 },
  RenataGlasc: { damageType: 'AP',    cc: 2, frontline: 1, scaling: 'mid',  engage: 1 },
  Soraka:      { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'mid',  engage: 0 },
  TahmKench:   { damageType: 'AP',    cc: 2, frontline: 3, scaling: 'mid',  engage: 2 },
  Thresh:      { damageType: 'AP',    cc: 3, frontline: 2, scaling: 'mid',  engage: 2 },
  Yuumi:       { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Zilean:      { damageType: 'AP',    cc: 1, frontline: 0, scaling: 'late', engage: 0 },
  Zyra:        { damageType: 'AP',    cc: 2, frontline: 0, scaling: 'mid',  engage: 1 },
};

// 主入口：传入 DataDragon idName + tags，返回该英雄的战术属性
export const getAttrs = (idName, tags = []) => {
  if (OVERRIDES[idName]) {
    return { ...OVERRIDES[idName], _source: 'override' };
  }
  // 回退：用第一个 tag 的默认值
  const firstValidTag = (tags || []).find((t) => TAG_BASE[t]);
  if (firstValidTag) {
    return { ...TAG_BASE[firstValidTag], _source: `tag:${firstValidTag}` };
  }
  // 终极兜底：中庸战士
  return { ...TAG_BASE.Fighter, _source: 'default' };
};

// 给一个 champion 对象（来自 useChampionData），返回完整属性
export const getChampionAttrs = (champion) => {
  if (!champion) return null;
  return getAttrs(champion.idName, champion.tags);
};

// 工具：统计一组英雄的总属性
export const summarizeTeam = (champions) => {
  const list = champions.filter(Boolean).map(getChampionAttrs).filter(Boolean);
  if (list.length === 0) {
    return {
      adCount: 0, apCount: 0, mixedCount: 0,
      totalCC: 0, totalFrontline: 0, totalEngage: 0,
      scaling: { early: 0, mid: 0, late: 0 },
      picks: 0,
    };
  }
  const summary = {
    adCount: list.filter((a) => a.damageType === 'AD').length,
    apCount: list.filter((a) => a.damageType === 'AP').length,
    mixedCount: list.filter((a) => a.damageType === 'mixed').length,
    totalCC: list.reduce((sum, a) => sum + a.cc, 0),
    totalFrontline: list.reduce((sum, a) => sum + a.frontline, 0),
    totalEngage: list.reduce((sum, a) => sum + a.engage, 0),
    scaling: {
      early: list.filter((a) => a.scaling === 'early').length,
      mid: list.filter((a) => a.scaling === 'mid').length,
      late: list.filter((a) => a.scaling === 'late').length,
    },
    picks: list.length,
  };
  return summary;
};
